import { Component, OnInit, DestroyRef, inject } from '@angular/core';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { TutorialService } from 'src/app/services/core/tutorials/tutorial.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { UserPermission } from 'src/app/enums/enums';
import { sweetAlert } from 'src/app/utils/swal';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, filter, Subject } from 'rxjs';
@UntilDestroy()
@Component({
  selector: 'app-tutorial-list',
  templateUrl: './tutorial-list.component.html',
  styleUrls: ['./tutorial-list.component.css']
})
export class TutorialListComponent implements OnInit {

  private destroyedRef = inject(DestroyRef);

  search: string = '';
  selectedStatus: boolean = true;
  status: boolean = true;
  currentPage = 1;
  totalPages = 0;
  totalResults = 0;
  type: string = 'all';
  numberOfRecords = NUMBER_OF_RECORDS;
  tutorialsList: any[] = [];
  filtertutorialsList: any[] = [];
  tutorialModalObj:any;
  userPermission=UserPermission;
  private searchSubject = new Subject<string>();

  constructor(
    public permissionService: PermissionService,
    private tutorialService: TutorialService)
     {}

  ngOnInit(): void {
    this.getTutorials(this.currentPage);
    this.initializeSearch();
  }

  getTutorials(page: number) {

    const queryparams: any = {
      page,
      limit: this.numberOfRecords,
      isActive: this.status,
      sortBy: 'createdAt:desc',
    };

    if (this.type && this.type !== 'all') {
      queryparams.type = this.type;
    }

    if (this.search?.trim()) {
      queryparams.search = this.search.trim();
    }

    this.tutorialService.getTutorials(queryparams)
    .subscribe({
        next: (data: any) => {
          this.tutorialsList = data?.results;
          this.filtertutorialsList = data?.results;
          this.totalPages = data?.totalPages;
          this.totalResults = data?.totalResults; 
        },
        error: (err) => {
          console.error(err);
        }
      });
  }

  onSearchInput() {
    this.currentPage = 1;
    this.getTutorials(this.currentPage);
  }

  onSelectStatus() {
    this.status = this.selectedStatus;
    this.currentPage = 1;
    this.getTutorials(this.currentPage);
  }
  
  onAcademyStatus(){
    this.currentPage = 1;
    this.getTutorials(this.currentPage);
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getTutorials(page);
  }

  openTutorialEditModal(tutorial: any) {
    this.tutorialModalObj = tutorial;
  }


  onSaveTutorial(evt: any) {
    if (evt) {
      const idx = this.filtertutorialsList.findIndex((t: any) => t.id === evt.id);
      if (this.status === evt.isActive) {
        this.filtertutorialsList[idx] = evt;
      } else {
        this.filtertutorialsList.splice(idx, 1);
      }
    }
    this.tutorialModalObj = null;
  }

  deleteTutorial(id: any) {
    sweetAlert('Warning', 'Are you sure you want to delete?', 'warning', 'Yes', 'No').then((result) => {
      console.log('result', result)
      if (result.isConfirmed) {
        this.tutorialService.deleteTutorial(id).pipe(untilDestroyed(this)).subscribe((data: any) => {
          // if (data) {
            sweetAlert('Success', 'Deleted successfully', 'success', 'OK');
             this.getTutorials(this.currentPage);
          // }
        })
      }
    })
  }
  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500), // wait for typing to stop
        filter((search: any) => !search || search.length >= 3)  // only trigger if >=3 chars OR empty (to reset search)
      ).subscribe(() => {
        this.currentPage = 1;
        this.getTutorials(this.currentPage);
      });
  }

   onCloseTutorialModal() {
    this.tutorialModalObj = null;
  }
}